/**
 * Example usage:
 *
 * paste({
 *     mode: 'copy',
 *     section: 'scorecards',
 *     // specify instead of section if you have a non-standard URL
 *     // (e.g. for BB slides).  Note copy or paste and a slash will be added
 *     // at the end, as appropriate
 *     url: 'api/briefings/1/slides/2',
 *     id: 1,
 *     parentId: 2, // can't be used at same time as orgId
 *     orgId: 3
 * }, function() {
 *     console.log('paste successful!')
 * })
 */
import $ from 'jquery'

import sections from 'scoreboard/components/sections'
import _ from 'lodash'

function paste(options, callback) {
	var prefix = (options.url || 'api/' + sections.toUrl(options.section) + '/' + options.id) + '/' + options.mode
	let params = _.pick(options, 'parentId', 'index', 'projectId', 'orgId',
		'confirmed', 'copyOwners', 'copyUpdaters', 'copyViewOrgPermissions',
		'copyActualValues', 'copyThresholdValues', 'copyNotes',
		'copyRelatedItems')
	var url = prefix + '?' + $.param(params)

	var xhrOptions = {
		method: 'post',
		url: url,
		data: JSON.stringify(options),
		success: callback
	}

	if (options.error) {
		xhrOptions.error = options.error
	}

	return $.ajax(xhrOptions)
}

export default paste

paste.__filename__ = 'components/paste/paste.js'
